import type { components, operations } from '@multaqa/api-client'
import { api } from '@/lib/api'

export type SupplierResource = components['schemas']['SupplierResource']
export type ContactResource = components['schemas']['ContactResource']
export type TagResource = components['schemas']['TagResource']
export type StoreSupplierRequest = components['schemas']['StoreSupplierRequest']
export type UpdateSupplierRequest = components['schemas']['UpdateSupplierRequest']
export type StoreContactRequest = components['schemas']['StoreContactRequest']

export type SupplierIndexParams = operations['supplier.index']['parameters']['query'] & {
  /** See the note on `CustomerIndexParams` — undeclared but supported. */
  search?: string
  page?: number
  per_page?: number
}

export async function fetchSuppliers(params?: SupplierIndexParams) {
  const response = await api.GET('/directory/suppliers', {
    params: {
      query: params,
    },
  })
  return response.data
}

export async function fetchSupplier(id: string) {
  const response = await api.GET('/directory/suppliers/{supplier}', {
    params: {
      path: { supplier: id },
    },
  })
  return response.data?.data
}

export async function createSupplier(data: StoreSupplierRequest) {
  const response = await api.POST('/directory/suppliers', {
    body: data,
  })
  return response.data?.data
}

export async function updateSupplier(id: string, data: UpdateSupplierRequest) {
  const response = await api.PUT('/directory/suppliers/{supplier}', {
    params: {
      path: { supplier: id },
    },
    body: data,
  })
  return response.data?.data
}

export async function deactivateSupplier(id: string) {
  const response = await api.POST('/directory/suppliers/{supplier}/deactivate', {
    params: {
      path: { supplier: id },
    },
  })
  return response.data?.data
}

export async function addSupplierContact(supplierId: string, data: StoreContactRequest) {
  const response = await api.POST('/directory/suppliers/{supplier}/contacts', {
    params: {
      path: { supplier: supplierId },
    },
    body: data,
  })
  return response.data?.data
}

export async function removeSupplierContact(supplierId: string, contactId: string) {
  await api.DELETE('/directory/suppliers/{supplier}/contacts/{contact}', {
    params: {
      path: { supplier: supplierId, contact: contactId },
    },
  })
}

export async function attachSupplierTag(supplierId: string, tagId: string) {
  const response = await api.POST('/directory/suppliers/{supplier}/tags/{tag}', {
    params: {
      path: { supplier: supplierId, tag: tagId },
    },
  })
  return response.data?.data
}

export async function detachSupplierTag(supplierId: string, tagId: string) {
  await api.DELETE('/directory/suppliers/{supplier}/tags/{tag}', {
    params: {
      path: { supplier: supplierId, tag: tagId },
    },
  })
}

export async function fetchTags() {
  const response = await api.GET('/directory/tags', {})
  return response.data?.data
}
